import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getUserStatuses,
  postUserStatus,
  deleteUserStatus as deleteUserStatusAPI,
  putUserStatus
} from '../lib/api'
import { RootState } from '../store'

type UserStatusState = {
  statuses: Array<APIUserStatus>
  loaded: boolean
  loading: boolean
  error: null | any
}
const initialState: UserStatusState = {
  statuses: [],
  loaded: false,
  loading: false,
  error: null
}

export const userStatusSlice = createSlice({
  name: 'userStatus',
  initialState,
  reducers: {
    loading: (state: UserStatusState) => {
      state.loading = true
    },
    load: (
      state: UserStatusState,
      { payload }: PayloadAction<Array<APIUserStatus>>
    ) => {
      state.statuses = payload
      state.loaded = true
      state.loading = false
    },
    add: (
      state: UserStatusState,
      { payload }: PayloadAction<APIUserStatus>
    ) => {
      state.statuses.push(payload)
    },
    remove: (state: UserStatusState, { payload }: PayloadAction<string>) => {
      const copy = state.statuses.filter(t => t.id !== payload)
      state.statuses = copy
    },
    update: (
      state: UserStatusState,
      { payload }: PayloadAction<APIUserStatus>
    ) => {
      const copy = state.statuses.map(t => {
        if (t.id === payload.id) {
          return payload
        }
        return t
      })
      state.statuses = copy
    },
    failed: (state: UserStatusState, { payload }: any) => {
      state.error = payload
      state.loading = false
      state.loaded = true
    }
  }
})

export default userStatusSlice.reducer

export const { loading, load, add, remove, update, failed } =
  userStatusSlice.actions

export const selectUserStatus = (state: RootState) => state.userStatus

// Asynchronous thunk action
export function fetchUserStatus () {
  return async dispatch => {
    dispatch(loading())
    try {
      const statuses = await getUserStatuses()
      dispatch(load(statuses))
    } catch (error) {
      console.error('Fetch error in ClientStatusSlice', error)
      dispatch(failed(error))
    }
  }
}

// Asynchronous thunk action
export function createUserStatus (newStatus) {
  return async dispatch => {
    const added = await postUserStatus(newStatus)
    dispatch(add(added))
  }
}

// Asynchronous thunk action
export function deleteUserStatus (id) {
  return async dispatch => {
    try {
      await deleteUserStatusAPI(id)
      dispatch(remove(id))
    } catch (err) {
      dispatch(failed(err))
    }
  }
}

// Asynchronous thunk action
export function updateUserStatus (id, newStatus) {
  return async dispatch => {
    try {
      const updated = await putUserStatus(id, newStatus)
      dispatch(update(updated))
    } catch (err) {
      dispatch(failed(err))
    }
  }
}
